export const LAMPS_END = "LAMPS_END"
export const LAMPS_START = "LAMPS_START"
export const CLOSE_SERVICE_RESULTS = "CLOSE_SERVICE_RESULTS"
export const SHOW_SERVICE_RESULTS = "SHOW_SERVICE_RESULTS"
export const SERVICE_ERROR = "SERVICE_ERROR"
